import { Container } from '@/components/base/container'
import { Skeleton } from '@/components/base/skeleton'
import { SingleColumnPage } from '@/components/page-layout'

export const GenericDetailSkeleton = () => (
	<SingleColumnPage>
		<div className='space-y-6'>
			{/* Header */}
			<div className='flex items-center justify-between'>
				<Skeleton className='h-10 w-64' />
				<Skeleton className='h-9 w-24' />
			</div>

			{/* Main content */}
			<Container>
				<div className='p-6'>
					<Skeleton className='mb-6 h-6 w-40' />
					<div className='space-y-4'>
						{Array.from({ length: 5 }).map((_, i) => (
							<div key={i} className='space-y-2'>
								<Skeleton className='h-4 w-32' />
								<Skeleton className='h-10 w-full' />
							</div>
						))}
					</div>
				</div>
			</Container>

			{/* Additional section */}
			<Container>
				<div className='p-6'>
					<Skeleton className='mb-4 h-6 w-36' />
					<div className='space-y-3'>
						{Array.from({ length: 3 }).map((_, i) => (
							<div key={i} className='flex items-center justify-between'>
								<Skeleton className='h-4 w-28' />
								<Skeleton className='h-4 w-20' />
							</div>
						))}
					</div>
				</div>
			</Container>
		</div>
	</SingleColumnPage>
)
